import React from 'react';
import { motion } from 'framer-motion';
import { Rocket, ArrowRight } from 'lucide-react';
import { Card } from '../../ui/card';
import { Button } from '../../ui/button';

const AskSlide = ({ data }) => {
  return (
    <div className="w-full max-w-5xl mx-auto text-center">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-8"
      >
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">{data.title}</h2>
        <p className="text-xl text-slate-400">{data.subtitle}</p>
      </motion.div>

      {/* Main Ask */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.2 }}
        className="mb-10"
      >
        <Card className="bg-gradient-to-br from-cyan-500/20 to-teal-500/20 border-cyan-500/30 p-10 inline-block">
          <div className="text-7xl md:text-8xl font-bold bg-gradient-to-r from-cyan-400 via-teal-400 to-emerald-400 bg-clip-text text-transparent mb-2">
            {data.request}
          </div>
          <p className="text-xl text-slate-300">{data.requestLabel}</p>
        </Card>
      </motion.div>

      {/* Impact Metrics */}
      <div className="grid grid-cols-3 gap-6 mb-10">
        {data.impact.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 + index * 0.1 }}
          >
            <Card className="bg-slate-800/50 border-slate-700/50 p-5">
              <div className="text-3xl font-bold text-emerald-400 mb-1">{item.metric}</div>
              <p className="text-slate-400 text-sm">{item.desc}</p>
            </Card>
          </motion.div>
        ))}
      </div>

      {/* Closing */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7 }}
      >
        <p className="text-xl text-slate-300 mb-8">{data.closing}</p>
        <div className="flex items-center justify-center gap-4">
          <Button size="lg" className="bg-gradient-to-r from-cyan-500 to-teal-500 text-white px-8 hover:opacity-90">
            <Rocket className="w-5 h-5 mr-2" />
            Schedule Demo
          </Button>
          <Button size="lg" variant="outline" className="border-slate-600 text-slate-300 hover:bg-slate-800">
            Contact Us
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default AskSlide;
